import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { Message } from 'projects/shared-lib/src/public-api';

@Component({
    selector: 'existing-household-modal',
    templateUrl: './existing-household-modal.component.html',
    styleUrls: ['./existing-household-modal.component.css']
})
export class ExistingHouseholdModalComponent implements OnInit {

    public householdIdControl: FormControl;

    constructor(public dialogRef: MatDialogRef<ExistingHouseholdModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            messageIds: Message[];
    }){
    }

    ngOnInit(){
        this.householdIdControl = new FormControl("", [Validators.required]);
    }

     public onConfirm(){
        this.dialogRef.close(this.householdIdControl.value);
    }
    
    public onCancel(){
        this.dialogRef.close(null);
    }

    public onSaveNew(){
        this.dialogRef.close(false);
    }
    
}